// Filename - components/SubMenu.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { el } from "date-fns/locale";


const SubMenu = ({ item,isOpen, onClick }) => {

    const { t } = useTranslation();


            

    const [subnav, setSubnav] = useState(false);

    const showSubnav = () => setSubnav(!subnav);

    // Styles as a JavaScript object
    const styles = {
        sidebarLink: {
            display: 'flex',
            color: 'black',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px',
            listStyle: 'none',
            height: '60px',
            textDecoration: 'none',
            fontSize: '18px'
        },
        sidebarLinkHover: {
            //background: '#252831',
            borderLeft: '4px solid green',
            cursor: 'pointer'
        },
        sidebarLabel: {
            marginLeft: '16px'
        },
        dropdownLink: {
            //background: '#252831',
            height: '60px',
            paddingLeft: '3rem',
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'black',
            fontSize: '18px'
        },
        dropdownLinkHover: {
            background: 'green',
            cursor: 'pointer'
        }
    };

    return (
        <>
            <Link
                to={item.path}
                style={{ ...styles.sidebarLink, color: isOpen ? 'blue' : 'black' }}
                onClick={(e) => {

                    if (item.subNav) {
                        showSubnav()   
                    }
                    onClick();
                  }}
                  onMouseEnter={(e) => e.target.style.background = ''} // Hover effect
                onMouseLeave={(e) => e.target.style.background = ''} // Reset hover effect
            >
                <div>
                    {item.icon}
                    <span style={styles.sidebarLabel}>
                        {t(`${item.title}`)}
                    </span>
                </div>
                <div>
                    {item.subNav && subnav
                        ? item.iconOpened
                        : item.subNav
                        ? item.iconClosed
                        : null}
                </div>
            </Link>
            {subnav &&
                item.subNav.map((item, index) => {
                    return (
                        <Link
                            to={item.path}
                            key={index}
                            style={styles.dropdownLink}
                            onMouseEnter={(e) => e.target.style.background = ''} // Hover effect
                            onMouseLeave={(e) => e.target.style.background = ''} // Reset hover effect
                        >
                            {item.icon}
                            <span style={styles.sidebarLabel}>
                            {t(`${item.title}`)}
                            </span>
                        </Link>
                    );
                })}
        </>
    );
};

export default SubMenu;
